import { render, staticRenderFns } from "./BDXManagementTableFiltersCreateDate.vue?vue&type=template&id=fbb9ccc8&scoped=true"
import script from "./BDXManagementTableFiltersCreateDate.vue?vue&type=script&lang=js"
export * from "./BDXManagementTableFiltersCreateDate.vue?vue&type=script&lang=js"
import style0 from "./BDXManagementTableFiltersCreateDate.vue?vue&type=style&index=0&id=fbb9ccc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb9ccc8",
  null
  
)

export default component.exports